import { combineReducers } from 'redux';
import productsReducer from '../features/product/product';
import appReducer from '../features/app/app';

export default combineReducers({
  app: appReducer,
  product: productsReducer
});
